module.exports = __webpack_public_path__ + "img/Lightbulb-Moment_wide_dark.271d26dc.png";